import { firebase, usersCollection } from '@/firebase';
import {actions} from "../constants";

const auth = {
  state: {
    user: null,
    profile: null,
    providerData: null,
    signUpData: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setProfile(state, payload) {
      state.profile = payload;
    },
    setProviderData(state, payload) {
      state.providerData = payload;
    },
    setSignUpData(state, payload) {
      state.signUpData = payload;
    },
  },
  actions: {
    signUp({commit}, payload) {
      const {
        email,
        password,
        first_name,
        last_name,
        language,
        dob,
        country,
        phone
      } = payload;
      return firebase.auth().
        createUserWithEmailAndPassword(email, password).
        then((result) => {
          commit('setSignUpData', {
            email,
            first_name,
            last_name,
            language,
            dob,
            phone,
            country,
            email_verified: false

          });
          return Promise.resolve(result.user);
        });
    },

    signIn({commit}, {email, password}) {
      return firebase.auth().signInWithEmailAndPassword(email, password);
    },

    signInWithGoogle({commit, dispatch}) {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('https://www.googleapis.com/auth/plus.login');
      provider.setCustomParameters({
        prompt: 'select_account',
      });
      return firebase.auth().signInWithPopup(provider).then(result => {
        const user = result.user;
        const additionalUserInfo = result.additionalUserInfo;
        const {
          providerId,
          isNewUser,
          profile: {
            email,
            family_name,
            given_name,
          },
        } = additionalUserInfo;

        const {
          uid, phoneNumber: phone, emailVerified: email_verified,
        } = user;

        const profileData = {
          email,
          first_name: given_name,
          last_name: family_name,
          phone,
          email_verified,
        };

        if (isNewUser) {
          commit('setProviderData', profileData);
        }
        return Promise.resolve(user);
      });
    },
    signOut({commit}) {
      return firebase.auth().signOut().then(() => {
        commit('setUser', null);
        commit('setProfile', null);
        commit('setProviderData', null);
        return Promise.resolve(true);
      });
    },

    updatePassword({state, commit}, {password}){
      const user = firebase.auth().currentUser;
      return user.updatePassword(password)
    },

    initUserSession({state, commit, dispatch}, user) {
      commit('setUser', {
        id: user.uid,
        phone: user.phoneNumber,
        displayName: user.displayName,
        email: user.email,
        email_verified: user.emailVerified,
      });

      const profilePromise = dispatch('getProfile')
       .then((profile) => {
        if (!profile) { // Create the new profile
          let profileData = {
            email: user.email,
            first_name: null,
            last_name: null,
            language: null,
            dob: null,
            phone: user.phone,
            email_verified: user.emailVerified,
          };

          if (state.providerData) {
            profileData = Object.assign({}, profileData, state.providerData || {});
          }else if(state.signUpData){
            profileData = Object.assign({}, profileData, state.signUpData || {});
          }
          return dispatch('updateProfile', profileData).then(() => {
             return Promise.resolve(true);
          });

        } else {
          commit('setProfile', profile);
          return Promise.resolve(true);
        }
      });

      return Promise.all([
        profilePromise,
        //dispatch(actions.CART_RESTORE_LAST_SESSION)
      ])


    },

    updateProfile({rootState, state, commit}, profile) {
      //const db = firebase.firestore();

      const newProfile = Object.assign({},state.profile, {

        first_name: profile.first_name || null,
        last_name: profile.last_name || null,
        dob: profile.dob || null,
        language: profile.language || null,
        country: profile.country || null,
        phone: profile.phone || null,
      });
      if(profile.email){
        newProfile.email = profile.email
      }

      if(typeof profile.email_verified == 'boolean'){
        newProfile.email_verified = profile.email_verified
      }


      const userRef = usersCollection.doc(state.user.id);
      return userRef.set(newProfile, {merge: true})
        .then(()=>{
          commit('setProfile',newProfile);
          return Promise.resolve(true);
      });
    },

    getProfile({rootState, state, commit}) {
      //const db = firebase.firestore();
      const userRef = usersCollection.doc(state.user.id);
      return userRef.get().then(doc => {
        if (!doc.exists) return null;
        const d = doc.data();
        const prof = Object.assign({}, d);
        prof.dob = d.dob?d.dob.toDate():null;
        return prof;
      });
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
  },
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/modules/auth.js